export type ReducerState = {
  byPartner: Record<string, { adSpend: number | null }>;
};

export const initialState: ReducerState = {
  byPartner: {},
};

export type ReducerAction = {
  type: 'ad_spend_changed';
  payload: {
    partner: string;
    adSpend: ReducerState['byPartner'][string]['adSpend'];
  };
};

export const reducer = (
  state: ReducerState,
  action: ReducerAction
): ReducerState => {
  return {
    ...state,
    byPartner: {
      ...state.byPartner,
      [action.payload.partner]: {
        ...state.byPartner[action.payload.partner],
        adSpend: action.payload.adSpend,
      },
    },
  };
};
